// #region Imports
import React, { useState, useRef } from "react"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import TableContainer from "../../components/Common/TableContainer"
import "react-datepicker/dist/react-datepicker.css"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { useFormik } from "formik"
import * as Yup from "yup"
import classnames from "classnames"
import { Link } from "react-router-dom"
import InputMask from "react-input-mask"

// #region Imports
import {
  Badge,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  UncontrolledAlert,
  UncontrolledTooltip,
} from "reactstrap"
// #endregion

// #region Import Components
import AltaGenerales from "./AltaGenerales"
import AltaAcademico from "./AltaAcademico"
import Documentacion from "../../components/Common/Documentacion"

import Breadcrumbs from "../../components/Common/Breadcrumb"

import Spinners from "components/Common/Spinner"
// #endregion

// #region selectors
import {
  useControlEscolarIsLoadingoPersona,
  useAuthPermiso,
  useControlEscolarError,
  useAuthIdPersonaAuthenticated,
  useControlEscolaroPhotoCredencial,
  useControlEscolaroNotificacion,
  useControlEscolaroPersona,
  useControlEscolaroAlumno,
  useCampusVirtualIdCampus,
  useCampusVirtualIsLoading,
  useCampusVirtualOptionsListaCampus,
  useCampusVirtualOptionsListaProgramasAcademicos,
  useCampusVirtualOptionsListaPlanesEstudio,
  useCampusVirtualOptionsListaTurnos,
  useCampusVirtualOptionsListaTrayectorias,
  useCampusVirtualOptionsListaStatus,
} from "store/selectors"
// #endregion

// #region Options
const estadosOptions = [
  { value: 1, label: "Aguascalientes" },
  { value: 2, label: "Baja California" },
  { value: 3, label: "Baja California Sur" },
  { value: 4, label: "Campeche" },
  { value: 5, label: "Chiapas" },
  { value: 6, label: "Chihuahua" },
  { value: 7, label: "Coahuila" },
  { value: 8, label: "Colima" },
  { value: 9, label: "Distrito Federal" },
  { value: 10, label: "Durango" },
  { value: 11, label: "Guerrero" },
  { value: 12, label: "Guanajuato" },
  { value: 13, label: "Hidalgo" },
  { value: 14, label: "Jalisco" },
  { value: 15, label: "México" },
  { value: 16, label: "Michoacán" },
  { value: 17, label: "Morelos" },
  { value: 18, label: "Nayarit" },
  { value: 19, label: "Nuevo León" },
  { value: 20, label: "Oaxaca" },
  { value: 21, label: "Puebla" },
  { value: 22, label: "Querétaro" },
  { value: 23, label: "Quintana Roo" },
  { value: 24, label: "San Luis Potosí" },
  { value: 25, label: "Sinaloa" },
  { value: 26, label: "Sonora" },
  { value: 27, label: "Tabasco" },
  { value: 28, label: "Tamaulipas" },
  { value: 29, label: "Tlaxcala" },
  { value: 30, label: "Veracruz" },
  { value: 31, label: "Yucatán" },
  { value: 32, label: "Zacatecas" },
  { value: 33, label: "Otro" },
]

const paisesOptions = [
  { value: 1, label: "Afganistán" },
  { value: 2, label: "Albania" },
  { value: 3, label: "Alemania" },
  { value: 4, label: "Andorra" },
  { value: 5, label: "Angola" },
  { value: 6, label: "Antigua y Barbuda" },
  { value: 7, label: "Arabia Saudita" },
  { value: 8, label: "Argelia" },
  { value: 9, label: "Argentina" },
  { value: 10, label: "Armenia" },
  { value: 11, label: "Australia" },
  { value: 12, label: "Austria" },
  { value: 13, label: "Azerbaiyán" },
  { value: 14, label: "Bahamas" },
  { value: 15, label: "Bahrein" },
  { value: 16, label: "Bangladesh" },
  { value: 17, label: "Barbados" },
  { value: 18, label: "Bielorrusia" },
  { value: 19, label: "Bélgica" },
  { value: 20, label: "Belice" },
  { value: 21, label: "Benín" },
  { value: 22, label: "Bhután" },
  { value: 23, label: "Bolivia" },
  { value: 24, label: "Bosnia y Herzegovina" },
  { value: 25, label: "Botswana" },
  { value: 26, label: "Brasil" },
  { value: 27, label: "Brunei Darussalam" },
  { value: 28, label: "Bulgaria" },
  { value: 29, label: "Burkina Faso" },
  { value: 30, label: "Burundi" },
  { value: 31, label: "Cabo Verde" },
  { value: 32, label: "Camboya" },
  { value: 33, label: "Camerún" },
  { value: 34, label: "Canadá" },
  { value: 35, label: "Chad" },
  { value: 36, label: "Chile" },
  { value: 37, label: "China" },
  { value: 38, label: "Chipre" },
  { value: 39, label: "Colombia" },
  { value: 40, label: "Comoras" },
  { value: 41, label: "Congo" },
  { value: 42, label: "Costa Rica" },
  { value: 43, label: "Côte d Ivoire" },
  { value: 44, label: "Croacia" },
  { value: 45, label: "Cuba" },
  { value: 46, label: "Dinamarca" },
  { value: 47, label: "Dominica" },
  { value: 48, label: "Ecuador" },
  { value: 49, label: "Egipto6" },
  { value: 50, label: "El Salvador" },
  { value: 51, label: "Emiratos Árabes Unidos" },
  { value: 52, label: "Eritrea" },
  { value: 53, label: "Eslovaquia" },
  { value: 54, label: "Eslovenia" },
  { value: 55, label: "España" },
  { value: 56, label: "Estados Unidos de América" },
  { value: 57, label: "Estonia" },
  { value: 58, label: "Etiopía" },
  { value: 59, label: "ex República Yugoslava de Macedonia" },
  { value: 60, label: "Federación Rusa" },
  { value: 61, label: "Fiji" },
  { value: 62, label: "Filipinas" },
  { value: 63, label: "Finlandia" },
  { value: 64, label: "Francia" },
  { value: 65, label: "Gabón" },
  { value: 66, label: "Gambia" },
  { value: 67, label: "Georgia" },
  { value: 68, label: "Ghana" },
  { value: 69, label: "Granada" },
  { value: 70, label: "Grecia" },
  { value: 71, label: "Guatemala" },
  { value: 72, label: "Guinea" },
  { value: 73, label: "Guinea-Bissau" },
  { value: 74, label: "Guinea Ecuatorial" },
  { value: 75, label: "Guyana" },
  { value: 76, label: "Haití" },
  { value: 77, label: "Honduras" },
  { value: 78, label: "Hungría" },
  { value: 79, label: "India" },
  { value: 80, label: "Indonesia" },
  { value: 81, label: "Irán, República Islámica de" },
  { value: 82, label: "Iraq" },
  { value: 83, label: "Irlanda" },
  { value: 84, label: "Islandia" },
  { value: 85, label: "Islas Marshall" },
  { value: 86, label: "Islas Salomón" },
  { value: 87, label: "Israel" },
  { value: 88, label: "Italia" },
  { value: 89, label: "Jamahiriya Árabe Libia" },
  { value: 90, label: "Jamaica" },
  { value: 91, label: "Japón" },
  { value: 92, label: "Jordania" },
  { value: 93, label: "Kazajistán" },
  { value: 94, label: "Kenya" },
  { value: 95, label: "Kirguistán" },
  { value: 96, label: "Kiribati" },
  { value: 97, label: "Kuwait" },
  { value: 98, label: "Lesoto" },
  { value: 99, label: "Letonia" },
  { value: 100, label: "Líbano" },
  { value: 101, label: "Liberia" },
  { value: 102, label: "Liechtenstein" },
  { value: 103, label: "Lituania" },
  { value: 104, label: "Luxemburgo" },
  { value: 105, label: "Madagascar" },
  { value: 106, label: "Malasia" },
  { value: 107, label: "Malaui" },
  { value: 108, label: "Maldivas" },
  { value: 109, label: "Malí" },
  { value: 110, label: "Malta" },
  { value: 111, label: "Marruecos" },
  { value: 112, label: "Mauricio" },
  { value: 113, label: "Mauritania" },
  { value: 114, label: "México" },
  { value: 115, label: "Micronesia, Estados Federados de" },
  { value: 116, label: "Mónaco" },
  { value: 117, label: "Montenegro" },
  { value: 118, label: "Mongolia" },
  { value: 119, label: "Mozambique" },
  { value: 120, label: "Birmania" },
  { value: 121, label: "Namibia" },
  { value: 122, label: "Nauru" },
  { value: 123, label: "Nepal" },
  { value: 124, label: "Nicaragua" },
  { value: 125, label: "Níger" },
  { value: 126, label: "Nigeria" },
  { value: 127, label: "Noruega" },
  { value: 128, label: "Nueva Zelanda" },
  { value: 129, label: "Omán" },
  { value: 130, label: "Países Bajos" },
  { value: 131, label: "Pakistán" },
  { value: 132, label: "Palaos" },
  { value: 133, label: "Panamá" },
  { value: 134, label: "Papúa Nueva Guinea" },
  { value: 135, label: "Paraguay" },
  { value: 136, label: "Perú" },
  { value: 137, label: "Polonia" },
  { value: 138, label: "Portugal" },
  { value: 139, label: "Qatar" },
  { value: 140, label: "Reino Unido de Gran Bretaña e Irlanda del Norte" },
  { value: 141, label: "República Árabe Siria" },
  { value: 142, label: "República Centroafricana" },
  { value: 143, label: "República Checa" },
  { value: 144, label: "República de Corea" },
  { value: 145, label: "República Democrática del Congo" },
  { value: 146, label: "República Democrática Popular Lao" },
  { value: 147, label: "República Dominicana" },
  { value: 148, label: "República de Moldova" },
  { value: 149, label: "República Popular Democrática de Corea" },
  { value: 150, label: "República Unida de Tanzania" },
  { value: 151, label: "Rumania" },
  { value: 152, label: "Ruanda" },
  { value: 153, label: "Saint Kitts y Nevis" },
  { value: 154, label: "Samoa" },
  { value: 155, label: "San Marino" },
  { value: 156, label: "Santa Lucía" },
  { value: 157, label: "Santo Tomé y Príncipe" },
  { value: 158, label: "San Vicente y las Granadinas" },
  { value: 159, label: "Senegal" },
  { value: 160, label: "Serbia" },
  { value: 161, label: "Seychelles" },
  { value: 162, label: "Sierra Leona" },
  { value: 163, label: "Singapur" },
  { value: 164, label: "Somalia" },
  { value: 165, label: "Sri Lanka" },
  { value: 166, label: "Sudáfrica" },
  { value: 167, label: "Sudán" },
  { value: 168, label: "Suecia" },
  { value: 169, label: "Suiza" },
  { value: 170, label: "Surinam" },
  { value: 171, label: "Suazilandia" },
  { value: 172, label: "Tailandia" },
  { value: 173, label: "Tayikistán" },
  { value: 174, label: "Timor-Leste" },
  { value: 175, label: "Togo" },
  { value: 176, label: "Tonga" },
  { value: 177, label: "Trinidad y Tobago" },
  { value: 178, label: "Túnez" },
  { value: 179, label: "Turkmenistán" },
  { value: 180, label: "Turquía" },
  { value: 181, label: "Tuvalu" },
  { value: 182, label: "Ucrania" },
  { value: 183, label: "Uganda" },
  { value: 184, label: "Uruguay" },
  { value: 185, label: "Uzbekistán" },
  { value: 186, label: "Vanuatu" },
  { value: 187, label: "Venezuela, República Bolivariana de" },
  { value: 188, label: "Viet Nam" },
  { value: 189, label: "Yemen" },
  { value: 190, label: "Yibuti" },
  { value: 191, label: "Zambia" },
  { value: 192, label: "Zimbabwe" },
]

const estadosCiviles = [
  { value: 1, label: "Soltero" },
  { value: 2, label: "Casado" },
  { value: 3, label: "Divorciado" },
  { value: 4, label: "Union Libre" },
  { value: 5, label: "Viudo" },
]
// #endregion

const now = new Date()

const AltaEstudiante = ({ onClose }) => {
  //meta title
  document.title = "Alta Estudiante | CampusVirtual" //

  // #region Init
  let oAspirante = {}

  const optionsFlatpickr = {
    locale: Spanish,
    altInput: true,
    dateFormat: "Y-m-d",
    enableTime: false,
  }
  // #endregion

  // #region const-selectors
  const isAdministradorGeneral = useAuthPermiso(["sis_administrador_general"])
  const notificacion = useControlEscolaroNotificacion()
  const error = useControlEscolarError()
  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  const oPhotoCredencial = useControlEscolaroPhotoCredencial()
  const isLoading = useControlEscolarIsLoadingoPersona()

  const oPersona = useControlEscolaroPersona()
  const oAlumnoDA = useControlEscolaroAlumno()
  const idCampusCurrent = useCampusVirtualIdCampus()
  const optionsCampus = useCampusVirtualOptionsListaCampus()
  const optionsProgramasAcademicos =
    useCampusVirtualOptionsListaProgramasAcademicos()
  const optionsPlanesEstudio = useCampusVirtualOptionsListaPlanesEstudio()
  const optionsTurnos = useCampusVirtualOptionsListaTurnos()
  const optionsTrayectorias = useCampusVirtualOptionsListaTrayectorias()
  const optionsStatus = useCampusVirtualOptionsListaStatus()
  // #endregion selectors

  // #region Internal States

  const [showPassword, setShowPassword] = useState(false)
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabVartical, setoggleTabVertical] = useState(1)

  const [passedSteps, setPassedSteps] = useState([1])
  const [passedStepsVertical, setPassedStepsVertical] = useState([1])
  const [show, setShow] = useState(false)

  // #endregion

  // #region useRef
  const flatpickrRef = useRef(null)
  // #endregion

  // #region Functions

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab]
      if (tab >= 1 && tab <= 6) {
        setactiveTab(tab)
        setPassedSteps(modifiedSteps)
      }
    }
  }

  const handleCampusChange = event => {
    //console.log("handleCampusChange")

    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const id_Campus = event.target.value

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, id_Campus)

    // //console.log("dispatching: getCampusVirtualCarreras")
    // dispatch(
    //   getCampusVirtualCarreras({
    //     nombreSolicitud: "getarbolprogramasacademicosxidcampus",
    //     idCampus: id_Campus,
    //   })
    // )
    // //console.log("dispatching: getCampusVirtualPlanes")
    // dispatch(
    //   getCampusVirtualPlanes({
    //     nombreSolicitud: "getarbolplanesestudioxidcampus",
    //     idCampus: id_Campus,
    //     idProgramaAcademico: 0,
    //   })
    // )
    // //console.log("dispatching: getCampusVirtualTurnos")
    // dispatch(
    //   getCampusVirtualTurnos({
    //     nombreSolicitud: "getarbolturnosxidcampusxidplanestudio",
    //     idCampus: id_Campus,
    //     idPlanEstudio: 0,
    //   })
    // )
  }
  // #endregion

  //#region Formik form

  const {
    id_Persona = -1,
    Apellido_Paterno = "",
    Apellido_Materno = "",
    Nombres = "",
    Curp = "",
    Email_Personal = "",
    Password = "",
    Telefono_Celular = "",
    Ciudad_Nacimiento = "",
    id_Estado_Nacimiento = 14,
    id_Pais_Nacimiento = 114,
    Fecha_Nacimiento = "",
    id_Estado_Civil = 1,
    Sexo_Masculino,
    //
    id_Direccion = -1,
    Calle = "",
    Numero_Exterior = "",
    Numero_Interior = "",
    Colonia = "",
    Municipio = "",
    Poblacion = "",
    id_Estado = "",
    id_Pais = "",
    Codigo_Postal = "",
    Apartado_Postal = "",
    Atencion = "",
    Coordenadas_GPS = "",
    Telefono_Fijo = "",
    Telefono_Fijo2 = "",
    Telefono_Fijo3 = "",
    Conmutador = "",
    Extension = "",
    Fax = "",
    // Datos Académicos
    id_Alumno = -1,
    id_Campus = idCampusCurrent,
    id_Programa_Academico = -1,
    id_Plan_Estudio = -1,
    id_Status = -1,
    id_Turno = -1,
    id_Turno_Extra = -1,
    id_Trayectoria = -1,
    id_Kardex = -1,
    Fecha_Inscripcion = now,
    En_Proceso_Revalidacion_Materias = false,
    Fecha_Inscripcion_SE = now,
    Fecha_Inicio_Clases = now,
    Revoe = "",
    Matricula_SE = "",
    Matricula_Inea = "",
    Matricula_Interna = "",
    Es_Oficial = false,
    Curso_Propedeutico = false,
    Importe_Inscripcion = 0.0,
    Importe_Mensualidad = 0.0,
    Responsable = "",
    Reingreso = false,
    Fecha_Reingreso = now,
  } = { oAspirante }

  const initialValues = {
    id_Persona,
    Apellido_Paterno,
    Apellido_Materno,
    Nombres,
    Curp,
    Email_Personal,
    Password,
    Telefono_Celular,
    Ciudad_Nacimiento,
    id_Estado_Nacimiento,
    id_Pais_Nacimiento,
    Fecha_Nacimiento: Fecha_Nacimiento.split("T")[0],
    id_Estado_Civil,
    Sexo: Sexo_Masculino ? 1 : 0,
    //
    id_Direccion,
    Calle,
    Numero_Exterior,
    Numero_Interior,
    Colonia,
    Municipio,
    Poblacion,
    idEstado: id_Estado,
    idPais: id_Pais,
    Codigo_Postal,
    Apartado_Postal,
    Atencion,
    Coordenadas_GPS,
    Telefono_Fijo,
    Telefono_Fijo2,
    Telefono_Fijo3,
    Conmutador,
    Extension,
    Fax,
    // datos academicos
    id_Alumno,
    id_Persona,
    id_Campus,
    id_Programa_Academico,
    id_Plan_Estudio,
    id_Status,
    id_Turno,
    id_Turno_Extra,
    id_Trayectoria,
    id_Kardex,
    Fecha_Inscripcion,
    En_Proceso_Revalidacion_Materias,
    Fecha_Inscripcion_SE,
    Fecha_Inicio_Clases,
    Rvoe: Revoe,
    Matricula_SE,
    Matricula_Inea,
    Matricula_Interna,
    Es_Oficial,
    Curso_Propedeutico,
    Importe_Inscripcion,
    Importe_Mensualidad,
    Responsable,
    Reingreso,
    Fecha_Reingreso,
  }

  const validationSchema = Yup.object({
    Apellido_Paterno: Yup.string()
      .matches(
        /^[A-Z]+(?: [A-Z]+)*$/,
        "Solo puede contener letras y un espacio entre palabras."
      )
      .required("Requerido"),
    Apellido_Materno: Yup.string().matches(
      /^[A-Z]+(?: [A-Z]+)*$/,
      "Solo puede contener letras y un espacio entre palabras."
    ),
    Nombres: Yup.string()
      .matches(
        /^[A-Z]+(?: [A-Z]+)*$/,
        "Solo puede contener letras y un espacio entre palabras."
      )
      .required("Requerido"),
    Curp: Yup.string()
      .length(18, "Debe tener 18 caracteres.")
      .matches(
        /^[A-Z]{4}\d{6}[HM][A-Z]{2}[BCDFGHJKLMNPQRSTVWXYZ]{3}[A-Z0-9]{2}$/
      )
      .required("Requerido"),
    Email_Personal: Yup.string()
      .email()
      .matches(/^(?!.*@[^,]*,)/)
      .required("Requerido"),
    Password: Yup.string()
      .min(6, "La longitud del password debe ser de al menos 6 caracteres.")
      .matches(RegExp("(.*[a-z].*)"), "Al menos una letra minúscula")
      .matches(RegExp("(.*[A-Z].*)"), "Al menos una letra mayúscula")
      .matches(RegExp("(.*[0-9].*)"), "Al menos un número")
      .required("Requerido"),
    Telefono_Celular: Yup.string()
      .matches(
        /^\d{10}$/,
        "El teléfono debe tener exactamente 10 dígitos y solo números."
      )
      .required("Requerido"),
    id_Estado_Nacimiento: Yup.number().required("Requerido"),
    id_Pais_Nacimiento: Yup.number().required("Requerido"),
    Fecha_Nacimiento: Yup.date().required("Requerido"),
    id_Estado_Civil: Yup.number().required("Requerido"),
    // Dirección
    Calle: Yup.string().matches(
      /^[A-Z0-9 #.]*$/,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
    Numero_Exterior: Yup.string().matches(
      /^[A-Z0-9 #.]*$/,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
    Numero_Interior: Yup.string().matches(
      /^[A-Z0-9 #.]*$/,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
    Colonia: Yup.string().matches(
      /^[A-Z0-9 #.]*$/,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
    Municipio: Yup.string().matches(
      /^[A-Z0-9 #.]*$/,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
    Poblacion: Yup.string().matches(
      /^[A-Z0-9 #.]*$/,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
    Apartado_Postal: Yup.string().matches(
      /^[A-Z0-9 #.]*$/,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
    Atencion: Yup.string().matches(
      /^[A-Z0-9 #.]*$/,
      "La calle solo puede contener letras mayúsculas, números, el signo de número '#' y puntos '.'."
    ),
    Codigo_Postal: Yup.string().matches(
      /^\d{5}$/,
      "El código postal debe tener cinco números."
    ),
    Telefono_Fijo: Yup.string().matches(
      /^\d{10}$/,
      "El teléfono debe tener exactamente 10 dígitos y solo números."
    ),
    Telefono_Fijo2: Yup.string().matches(
      /^\d{10}$/,
      "El teléfono debe tener exactamente 10 dígitos y solo números."
    ),
    Telefono_Fijo3: Yup.string().matches(
      /^\d{10}$/,
      "El teléfono debe tener exactamente 10 dígitos y solo números."
    ),
    idEstado: Yup.number().required("Requerido"),
    idPais: Yup.number().required("Requerido"),
  })

  const onSubmit = values => {
    //console.log("Form data", values)
    // dispatch(
    //   onPutControlEscolarPutPersona({
    //     nombreSolicitud: "updatepersona",
    //     oPersona: values,
    //     idAlumno: idAlumno,
    //     idPersona: idPersonaAuthenticated,
    //   })
    // )
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true,
  })

  const handleUpperCaseChange = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value.toUpperCase()

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)
  }

  const handleProgramaAcademicoChange = event => {
    //console.log("handleProgramaAcademicoChange")

    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)

    //console.log("dispatching: getCampusVirtualPlanes")
    dispatch(
      getCampusVirtualPlanes({
        nombreSolicitud: "getarbolplanesestudioxidcampus",
        idCampus: formik.values.id_Campus,
        idProgramaAcademico: value,
      })
    )
  }

  const handlePlanEstudioChange = event => {
    //console.log("handlePlanEstudioChange")

    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)

    console.log("dispatching: getCampusVirtualTurnos")
    dispatch(
      getCampusVirtualTurnos({
        nombreSolicitud: "getarbolturnosxidcampusxidplanestudio",
        idCampus: formik.values.id_Campus,
        idPlanEstudio: event.target.value,
      })
    )

    console.log("dispatching: getCampusVirtualTrayectorias")
    dispatch(
      getCampusVirtualTrayectorias({
        nombreSolicitud: "getarboltrayectoriaxdcampusxidplanestudio",
        idCampus: formik.values.id_Campus,
        idPlanEstudio: event.target.value,
      })
    )
  }

  const handleLowerCaseChange = event => {
    // Obtiene el nombre del campo y el valor en mayúsculas
    const name = event.target.name
    const value = event.target.value.toLowerCase()

    // Utiliza Formik para actualizar el valor
    formik.setFieldValue(name, value)
  }

  // #endregion

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={"Control Escolar"}
            breadcrumbItem={"Alta Alumno"}
          />

          <Row className="">
            <div className="wizard clearfix">
              <div className="steps clearfix">
                <ul>
                  <NavItem className={classnames({ current: activeTab === 1 })}>
                    <NavLink
                      className={classnames({ current: activeTab === 1 })}
                      onClick={() => {
                        setactiveTab(1)
                      }}
                      disabled={!(passedSteps || []).includes(1)}
                    >
                      <span className="number">1.</span> Generales
                    </NavLink>
                  </NavItem>
                  <NavItem className={classnames({ current: activeTab === 2 })}>
                    <NavLink
                      className={classnames({ active: activeTab === 2 })}
                      onClick={() => {
                        setactiveTab(2)
                      }}
                      disabled={!(passedSteps || []).includes(2)}
                    >
                      <span className="number">2.</span> Académicos
                    </NavLink>
                  </NavItem>
                  <NavItem className={classnames({ current: activeTab === 3 })}>
                    <NavLink
                      className={classnames({ active: activeTab === 3 })}
                      onClick={() => {
                        setactiveTab(3)
                      }}
                      disabled={!(passedSteps || []).includes(3)}
                    >
                      <span className="number">3.</span> Cargos
                    </NavLink>
                  </NavItem>
                  <NavItem className={classnames({ current: activeTab === 4 })}>
                    <NavLink
                      className={classnames({ active: activeTab === 4 })}
                      onClick={() => {
                        setactiveTab(4)
                      }}
                      disabled={!(passedSteps || []).includes(4)}
                    >
                      <span className="number">4.</span> Docs
                    </NavLink>
                  </NavItem>
                  <NavItem className={classnames({ current: activeTab === 5 })}>
                    <NavLink
                      className={classnames({ active: activeTab === 5 })}
                      onClick={() => {
                        setactiveTab(5)
                      }}
                      disabled={!(passedSteps || []).includes(5)}
                    >
                      <span className="number">5.</span> Factura
                    </NavLink>
                  </NavItem>
                  <NavItem className={classnames({ current: activeTab === 6 })}>
                    <NavLink
                      className={classnames({ active: activeTab === 6 })}
                      onClick={() => {
                        setactiveTab(6)
                      }}
                      disabled={!(passedSteps || []).includes(6)}
                    >
                      <span className="number">6.</span> Resumen
                    </NavLink>
                  </NavItem>
                </ul>
              </div>
            </div>
          </Row>

          <Row>
            <TabContent activeTab={activeTab} className="body mt-2">
              {/* Generales y Dirección */}
              <TabPane tabId={1}>
                <Card>
                  <CardBody>
                    <AltaGenerales
                      formik={formik}
                      idAlumno={1}
                      handleUpperCaseChange={handleUpperCaseChange}
                      handleLowerCaseChange={handleLowerCaseChange}
                      oPersona={{}}
                      isEdit={true}
                    />
                  </CardBody>
                </Card>
                <Card>
                  <CardTitle className="mt-3 ms-3 mb-0">Dirección</CardTitle>
                  <CardBody>
                    {/* Calle, #Exterior, #Interior, Colonia */}
                    <Row>
                      <Col md={4}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Calle-Input">Calle</Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Calle"
                              className="form-control"
                              id="formrow-Calle-Input"
                              placeholder="Calle"
                              autoComplete="off"
                              value={formik.values.Calle}
                              onChange={handleUpperCaseChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Calle && formik.errors.Calle
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}
                          {formik.errors.Calle && formik.touched.Calle ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Calle}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={2}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Numero_Exterior-Input">
                            Número Exterior
                          </Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Numero_Exterior"
                              className="form-control"
                              id="formrow-Numero_Exterior-Input"
                              placeholder="#Exterior"
                              autoComplete="off"
                              value={formik.values.Numero_Exterior}
                              onChange={handleUpperCaseChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Numero_Exterior &&
                                formik.errors.Numero_Exterior
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}
                          {formik.errors.Numero_Exterior &&
                          formik.touched.Numero_Exterior ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Numero_Exterior}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={2}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Numero_Interior-Input">
                            # Interior
                          </Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Numero_Interior"
                              className="form-control"
                              id="formrow-Numero_Interior-Input"
                              placeholder="Número interior"
                              autoComplete="off"
                              value={formik.values.Numero_Interior}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Numero_Interior &&
                                formik.errors.Numero_Interior
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Numero_Interior &&
                          formik.touched.Numero_Interior ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Numero_Interior}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={4}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Colonia-Input">Colonia</Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Colonia"
                              className="form-control"
                              id="formrow-Colonia-Input"
                              placeholder="Colonia"
                              autoComplete="off"
                              value={formik.values.Colonia}
                              onChange={handleUpperCaseChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Colonia && formik.errors.Colonia
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Colonia && formik.touched.Colonia ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Colonia}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    {/* Municipio, Ciudad, Estado, Pais */}
                    <Row>
                      {/* Municipio */}
                      <Col md={3}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Municipio-Input">
                            Municipio
                          </Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Municipio"
                              className="form-control"
                              id="formrow-Municipio-Input"
                              placeholder="Municipio"
                              autoComplete="off"
                              value={formik.values.Municipio}
                              onChange={handleUpperCaseChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Municipio &&
                                formik.errors.Municipio
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Municipio &&
                          formik.touched.Municipio ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Municipio}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      {/* Ciudad */}
                      <Col md={3}>
                        <div className="mb-3">
                          <Label htmlFor="formrow-Ciudad-Input">
                            Ciudad / Población
                          </Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Ciudad"
                              className="form-control"
                              id="formrow-Ciudad-Input"
                              placeholder="Escribe tu Ciudad"
                              autoComplete="off"
                              value={formik.values.Ciudad}
                              onChange={handleUpperCaseChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Ciudad && formik.errors.Ciudad
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Ciudad && formik.touched.Ciudad ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Ciudad}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      {/* Estado */}
                      <Col lg={3}>
                        <div className="mb-3">
                          <Label htmlFor="formrow-InputidEstado">
                            * Estado
                          </Label>
                          {!isLoading ? (
                            <select
                              name="idEstado"
                              id="formrow-InputidEstado"
                              className="form-control form-select"
                              value={formik.values.idEstado}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              <option value={-1}>Elige...</option>
                              {estadosOptions.map(option => {
                                return (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                )
                              })}
                            </select>
                          ) : (
                            <p aria-hidden="true" className="mt-2">
                              <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                            </p>
                          )}
                          {formik.errors.idEstado && formik.touched.idEstado ? (
                            <span className="text-danger">
                              {formik.errors.idEstado}
                            </span>
                          ) : null}
                        </div>
                      </Col>

                      {/* Pais */}
                      <Col lg={3}>
                        <div className="mb-3">
                          <Label htmlFor="formrow-idPais">* País</Label>
                          {!isLoading ? (
                            <select
                              name="idPais"
                              id="formrow-idPais"
                              className="form-control form-select"
                              value={formik.values.idPais}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              <option value={-1}>Elige...</option>
                              {paisesOptions.map(option => {
                                return (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                )
                              })}
                            </select>
                          ) : (
                            <p aria-hidden="true" className="mt-2">
                              <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                            </p>
                          )}
                          {formik.errors.idPais && formik.touched.idPais ? (
                            <FormFeedback type="invalid">
                              {formik.errors.idPais}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    {/* Cp, Apartado Postal, Atención, GPS */}
                    <Row>
                      {/* Código Postal */}
                      <Col md={3}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Codigo_Postal-Input">
                            Código Postal
                          </Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Codigo_Postal"
                              className="form-control"
                              id="formrow-Codigo_Postal-Input"
                              placeholder="Zip code"
                              autoComplete="off"
                              value={formik.values.Codigo_Postal}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Codigo_Postal &&
                                formik.errors.Codigo_Postal
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Codigo_Postal &&
                          formik.touched.Codigo_Postal ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Telefono_Celular}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      {/* Apartado Postal */}
                      <Col md={3}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Apartado_Postal-Input">
                            Apartado Postal
                          </Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Apartado_Postal"
                              className="form-control"
                              id="formrow-Apartado_Postal-Input"
                              placeholder="Apartado Postal"
                              autoComplete="off"
                              value={formik.values.Apartado_Postal}
                              onChange={handleUpperCaseChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Apartado_Postal &&
                                formik.errors.Apartado_Postal
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Apartado_Postal &&
                          formik.touched.Apartado_Postal ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Apartado_Postal}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      {/* Atención */}
                      <Col md={3}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Atencion-Input">
                            Atención
                          </Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Atencion"
                              className="form-control"
                              id="formrow-Atencion-Input"
                              placeholder="Atención"
                              autoComplete="off"
                              value={formik.values.Atencion}
                              onChange={handleUpperCaseChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Atencion &&
                                formik.errors.Atencion
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Atencion && formik.touched.Atencion ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Atencion}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      {/* Gps */}
                      <Col md={3}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Coordenadas_GPS-Input">
                            Coordendas GPS
                          </Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Coordenadas_GPS"
                              className="form-control"
                              id="formrow-Coordenadas_GPS-Input"
                              placeholder="Coordenadas GPS"
                              autoComplete="off"
                              value={formik.values.Coordenadas_GPS}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Coordenadas_GPS &&
                                formik.errors.Coordenadas_GPS
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Coordenadas_GPS &&
                          formik.touched.Coordenadas_GPS ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Coordenadas_GPS}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    {/* Linea Teléfonos */}
                    <Row className="mb-2">
                      <Col>
                        <h5>Teléfonos.</h5>
                      </Col>
                    </Row>
                    {/* Telefono Fijo, Telefono Fijo2, Telefono Fijo 3 */}
                    <Row>
                      <Col md={3}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Telefono_Fijo-Input">
                            Teléfono
                          </Label>
                          {!isLoading ? (
                            <InputMask
                              mask="(99) 99-99-99-99"
                              type="text"
                              name="Telefono_Fijo"
                              className="form-control"
                              id="formrow-Telefono_Fijo-Input"
                              placeholder="Teléfono"
                              autoComplete="off"
                              value={formik.values.Telefono_Fijo}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Telefono_Fijo &&
                                formik.errors.Telefono_Fijo
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Telefono_Fijo &&
                          formik.touched.Telefono_Fijo ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Telefono_Fijo}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={3}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Telefono_Fijo2-Input">
                            Teléfono 2
                          </Label>
                          {!isLoading ? (
                            <InputMask
                              mask="(99) 99-99-99-99"
                              type="text"
                              name="Telefono_Fijo2"
                              className="form-control"
                              id="formrow-Telefono_Fijo2-Input"
                              placeholder="Teléfono"
                              autoComplete="off"
                              value={formik.values.Telefono_Fijo2}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Telefono_Fijo2 &&
                                formik.errors.Telefono_Fijo2
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Telefono_Fijo2 &&
                          formik.touched.Telefono_Fijo2 ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Telefono_Fijo2}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={3}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Telefono_Fijo3-Input">
                            Teléfono 3
                          </Label>
                          {!isLoading ? (
                            <InputMask
                              mask="(99) 99-99-99-99"
                              type="text"
                              name="Telefono_Fijo3"
                              className="form-control"
                              id="formrow-Telefono_Fijo3-Input"
                              placeholder="Teléfono"
                              autoComplete="off"
                              value={formik.values.Telefono_Fijo3}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Telefono_Fijo3 &&
                                formik.errors.Telefono_Fijo3
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Telefono_Fijo3 &&
                          formik.touched.Telefono_Fijo3 ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Telefono_Fijo3}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    {/* Conmutador, Extensión, Fax */}
                    <Row>
                      <Col md={3}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Conmutador-Input">
                            Conmutador
                          </Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Conmutador"
                              className="form-control"
                              id="formrow-Conmutador-Input"
                              placeholder="Conmutador"
                              autoComplete="off"
                              value={formik.values.Conmutador}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Conmutador &&
                                formik.errors.Conmutador
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Conmutador &&
                          formik.touched.Conmutador ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Conmutador}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={3}>
                        {" "}
                        <div className="mb-3">
                          <Label htmlFor="formrow-Extension-Input">
                            Extensión
                          </Label>
                          {!isLoading ? (
                            <Input
                              type="text"
                              name="Extension"
                              className="form-control"
                              id="formrow-Extension-Input"
                              placeholder="Extensión"
                              autoComplete="off"
                              value={formik.values.Extension}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Extension &&
                                formik.errors.Extension
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Extension &&
                          formik.touched.Extension ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Extension}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className="mb-3">
                          <Label htmlFor="formrow-Fax">Fax</Label>
                          {!isLoading ? (
                            <InputMask
                              mask="(99) 99-99-99-99"
                              type="text"
                              name="Fax"
                              className="form-control"
                              id="formrow-Fax"
                              placeholder="Fax"
                              autoComplete="off"
                              value={formik.values.Fax}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              invalid={
                                formik.touched.Fax && formik.errors.Fax
                                  ? true
                                  : false
                              }
                            />
                          ) : (
                            <div>
                              <p aria-hidden="true" className="mt-2">
                                <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
                              </p>
                            </div>
                          )}

                          {formik.errors.Fax && formik.touched.Fax ? (
                            <FormFeedback type="invalid">
                              {formik.errors.Fax}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </TabPane>
              {/* Datos Académicos */}
              <TabPane tabId={2}>
                <Card>
                  <CardBody>
                    {/* {activeTab === 2 &&  */}
                    {/* <AltaAcademico
                      formik={formik}
                      handleUpperCaseChange={handleUpperCaseChange}
                      handleLowerCaseChange={handleLowerCaseChange}
                      activeTab={activeTab === 2}
                    /> */}
                    {/* } */}
                  </CardBody>
                </Card>
              </TabPane>
              {/* Cargos */}
              <TabPane tabId={3}>
                <div>
                  {/* <Form>
                    <Row>
                      <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-namecard-input11">
                            Promociones - Descuentos - Becas
                          </Label>
                          <select
                            name="promociones"
                            id="formrow-InputPromociones"
                            className="form-control"
                            value={formik.values.Promociones}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          >
                            <option value={-1}>Elige...</option>
                            {estadosCiviles.map(option => {
                              return (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              )
                            })}
                          </select>
                        </div>
                      </Col>

                      <Col lg="6">
                        <div className="mb-3">
                          <Label>Colegiatura</Label>
                          <select className="form-select">
                            <option defaultValue>Mensual</option>
                            <option value="AE">Semanal</option>
                          </select>
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Row className="mb-0">
                        <Label for="basicpill-cardno-input12">
                          <h4>Inscripción</h4>
                        </Label>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <Row>
                            <div className="mb-3">
                              <Label for="basicpill-cardno-input12">
                                A partir de:
                              </Label>
                              <InputGroup>
                                <Flatpickr
                                  ref={flatpickrRef}
                                  options={optionsFlatpickr}
                                  name="formrow-Fecha_Inicio_Clases"
                                  className="form-control d-block"
                                  id="formrow-Fecha_Inicio_Clases"
                                  placeholder="Fecha de nacimiento"
                                  value={formik.values.Fecha_Inicio_Clases}
                                  onChange={(
                                    selectedDates,
                                    dateStr,
                                    instance
                                  ) => {
                                    formik.setFieldValue(
                                      "Fecha_Inicio_Clases",
                                      dateStr
                                    )
                                  }}
                                  onBlur={formik.handleBlur}
                                  invalid={
                                    formik.touched.Fecha_Inicio_Clases &&
                                    formik.errors.Fecha_Inicio_Clases
                                      ? true
                                      : false
                                  }
                                />

                                <div
                                  className="input-group-text"
                                  style={{ cursor: "pointer" }}
                                >
                                  <i className={`bx bx-calendar`}></i>
                                </div>
                              </InputGroup>
                            </div>
                          </Row>
                        </Col>

                        <Col lg="6">
                          <Row>
                            <div className="mb-3">
                              <Label for="basicpill-cardno-input12">
                                Descuento
                              </Label>

                              <select className="form-select">
                                <option defaultValue>30% Inscripción</option>
                                <option value="AE">50% Buen Fin</option>
                              </select>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <Row>
                            <div className="mb-3">
                              <Label for="basicpill-cardno-input12">
                                A pagar:
                              </Label>
                              <Input
                                type="text"
                                name="Matriasdfcula_Inea"
                                className="form-control"
                                id="formrow-Matricula_Inea-Input"
                                placeholder=""
                                value={formik.values.Matricula_Inea}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={
                                  formik.touched.Matricula_Inea &&
                                  formik.errors.Matricula_Inea
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        </Col>

                        <Col lg="6">
                          <Row>
                            <div className="mb-3">
                              <Label for="basicpill-cardno-input12">
                                Costo de la inscripción a pagar:
                              </Label>

                              <Input
                                type="text"
                                name="Matricasdfula_Inea"
                                className="form-control"
                                id="formrow-Matricula_Inea-Input"
                                placeholder=""
                                value={formik.values.Matricula_Inea}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={
                                  formik.touched.Matricula_Inea &&
                                  formik.errors.Matricula_Inea
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </Row>

                    <Row>
                      <Row>
                        <Label for="basicpill-cardno-input12">
                          <h4>Colegiatura</h4>
                        </Label>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <Row>
                            <div className="mb-3">
                              <Label for="basicpill-cardno-input12">
                                A partir de:
                              </Label>
                              <InputGroup>
                                <Flatpickr
                                  ref={flatpickrRef}
                                  options={optionsFlatpickr}
                                  name="formrow-Fecha_Inicio_Clases"
                                  className="form-control d-block"
                                  id="formrow-Fecha_Inicio_Clases"
                                  placeholder="Fecha de nacimiento"
                                  value={formik.values.Fecha_Inicio_Clases}
                                  onChange={(
                                    selectedDates,
                                    dateStr,
                                    instance
                                  ) => {
                                    formik.setFieldValue(
                                      "Fecha_Inicio_Clases",
                                      dateStr
                                    )
                                  }}
                                  onBlur={formik.handleBlur}
                                  invalid={
                                    formik.touched.Fecha_Inicio_Clases &&
                                    formik.errors.Fecha_Inicio_Clases
                                      ? true
                                      : false
                                  }
                                />

                                <div
                                  className="input-group-text"
                                  style={{ cursor: "pointer" }}
                                >
                                  <i className={`bx bx-calendar`}></i>
                                </div>
                              </InputGroup>
                            </div>
                          </Row>
                        </Col>

                        <Col lg="6">
                          <Row>
                            <div className="mb-3">
                              <Label for="basicpill-cardno-input12">
                                Descuento
                              </Label>

                              <select className="form-select">
                                <option defaultValue>30% Colegiatura</option>
                                <option value="AE">50% Buen Fin</option>
                              </select>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <Row>
                            <div className="mb-3">
                              <Label for="basicpill-cardno-input12">
                                A pagar:
                              </Label>
                              <Input
                                type="text"
                                name="Matriasdfcula_Inea"
                                className="form-control"
                                id="formrow-Matricula_Inea-Input"
                                placeholder=""
                                value={formik.values.Matricula_Inea}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={
                                  formik.touched.Matricula_Inea &&
                                  formik.errors.Matricula_Inea
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        </Col>

                        <Col lg="6">
                          <Row>
                            <div className="mb-3">
                              <Label for="basicpill-cardno-input12">
                                Costo de la colegiatura a pagar:
                              </Label>

                              <Input
                                type="text"
                                name="Matricasdfula_Inea"
                                className="form-control"
                                id="formrow-Matricula_Inea-Input"
                                placeholder=""
                                value={formik.values.Matricula_Inea}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                invalid={
                                  formik.touched.Matricula_Inea &&
                                  formik.errors.Matricula_Inea
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </Row>
                  </Form> */}
                </div>
              </TabPane>
              {/* Documentos */}
              <TabPane tabId={4}>
                <div className="row justify-content-center">
                  <Col lg="6">
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                      </div>
                      <div>
                        <h5>Confirm Detail</h5>
                        <p className="text-muted">
                          If several languages coalesce, the grammar of the
                          resulting
                        </p>
                      </div>
                    </div>
                  </Col>
                </div>
              </TabPane>
              {/* Facturacion */}
              <TabPane tabId={5}>
                <div className="row justify-content-center">
                  <Col lg="6">
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                      </div>
                      <div>
                        <h5>Confirm Detail</h5>
                        <p className="text-muted">
                          If several languages coalesce, the grammar of the
                          resulting
                        </p>
                      </div>
                    </div>
                  </Col>
                </div>
              </TabPane>
              {/* Resumen */}
              <TabPane tabId={6}>
                <div className="row justify-content-center">
                  <Col lg="6">
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                      </div>
                      <div>
                        <h5>Confirm Detail</h5>
                        <p className="text-muted">
                          If several languages coalesce, the grammar of the
                          resulting
                        </p>
                      </div>
                    </div>
                  </Col>
                </div>
              </TabPane>
            </TabContent>
          </Row>

          {/* Botones Anterior - Siguiente */}
          <Row>
            <div className="wizard clearfix">
              <div className="actions clearfix">
                <ul>
                  <li
                    className={
                      activeTab === 1 ? "previous disabled" : "previous"
                    }
                  >
                    <Link
                      to="#"
                      onClick={() => {
                        toggleTab(activeTab - 1)
                      }}
                    >
                      Anterior
                    </Link>
                  </li>
                  <li className={activeTab === 6 ? "next disabled" : "next"}>
                    <Link
                      to="#"
                      onClick={() => {
                        toggleTab(activeTab + 1)
                      }}
                    >
                      Siguiente
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AltaEstudiante
